import _ from 'lodash';
import * as at from './actionTypes';
import {
  ENTRIES_DELETED,
  ENTRY_ADD,
  ENTRY_ADD_FAILURE,
  ENTRY_ADD_SUCCESS,
  ENTRIES_FETCH,
  ENTRIES_FETCH_SUCCESS,
  TAG_DELETE,
  TAG_DELETE_SUCCESS,
  TAG_DELETE_FAILURE
} from 'data/actionTypes';

const INITIAL_STATE = {
  filterTags: [], // [{id: index, text: tagname}, ...] -- Tags that have been selected from drop down in order to filter entries
  tagsUpdated: [], // [tagname, tagname, ...] -- Tags that have just been added/deleted to dropdown
  entriesSelected: [], // [entryID, ...]
  entrySelected: false,
  loading: false,
  readFilter: '',
  searchText: '', // Used to filter entries by the text in the search bar
  sortedByTags: false,
  tagDeleteInProgress: null,
  addModalOpen: false,
  groupsSelected: []
}

const DONE_EDITING_STATE = {
  filterTags: [],
  tagsUpdated: [],
  entriesSelected: [],
  entrySelected: false,
  addTagsLoading: false,
  loading: false,
  groupsSelected: []
}

export const reducer = (state = INITIAL_STATE, action) => {
  let newEntriesSelected;

  switch(action.type) {
    case at.UNMOUNTING:
      return INITIAL_STATE;

    // Display
    case at.TOGGLE_SHOW_READ:
      return { ...state, readFilter: action.payload };
    case at.TOGGLE_SORT_ORDER:
      return { ...state, sortedByTags: !state.sortedByTags };
    case at.TOGGLE_ADD_MODAL:
      return { ...state, addModalOpen: action.payload}
    case at.SEARCH_TEXT_UPDATED:
      return { ...state, searchText: action.payload}

    // Filtering by tag
    case at.TAG_FILTER_UPDATE:
      return { ...state, filterTags: action.payload, searchText: '' }
    case TAG_DELETE:
      return { ...state, tagDeleteInProgress: action.payload }
    case TAG_DELETE_FAILURE:
    case TAG_DELETE_SUCCESS:
      return { ...state, tagDeleteInProgress: null }

    // Adding tags
    case at.TAGS_UPDATED_IN_SELECTION:
      return {
        ...state,
        tagsUpdated: action.payload,
      };

    // Editing entries
    case at.ENTRY_SELECTED:
      const id = action.payload;
      return {
        ...state,
        entrySelected: true,
        entriesSelected: [...state.entriesSelected, id ],
        tagsUpdated: [] // ensures that "Tags selected" are calculated properly
      };
    case at.ENTRY_UNSELECTED:
      const unselectedId = action.payload;
      newEntriesSelected = _.filter(state.entriesSelected, (id) => id !== unselectedId);
      return {
        ...state,
        entrySelected: state.entriesSelected.length > 1,
        entriesSelected: newEntriesSelected,
        tagsUpdated: [] // ensures that "Tags selected" are calculated properly
      };
    case at.GROUP_SELECTED:
      return {
        ...state,
        groupsSelected: action.payload
      };

    // Retrieving and Adding data to cloud firestore
    case ENTRIES_DELETED:
      return {
        ...state,
        entriesSelected: _.difference(state.entriesSelected, action.payload)
      }
    case ENTRY_ADD:
    case ENTRIES_FETCH:
      return { ...state, loading: true }
    case ENTRY_ADD_SUCCESS:
    case ENTRY_ADD_FAILURE:
    case ENTRIES_FETCH_SUCCESS:
      return { ...state, loading: false }
    case at.DONE_WITH_SELECTION:
      return { ...state, entriesSelected: [], entrySelected: false }
    case at.CANCEL_EDITING:
    case at.DONE_EDITING:
      return { ...state, ...DONE_EDITING_STATE}
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/scenes/Main/reducer.js